/* EMBOZZ — blog + inner-page behaviour and traffic tracking.
   Pushes to the same window.dataLayer used by campaign.js. */
(function () {
  function track(name, params) {
    window.dataLayer = window.dataLayer || [];
    var p = { event: name };
    if (params) for (var k in params) p[k] = params[k];
    window.dataLayer.push(p);
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  }

  /* ---- where did this visitor come from? ---- */
  var ref = document.referrer || '';
  var src = 'direct';
  if (/google|bing|duckduckgo|yahoo|ecosia/i.test(ref)) src = 'organic_search';
  else if (/facebook|instagram|linkedin|t\.co|twitter|x\.com|tiktok|threads|pinterest/i.test(ref)) src = 'social';
  else if (ref && ref.indexOf(location.hostname) === -1) src = 'referral';
  else if (ref) src = 'internal';
  if (/[?&]utm_/.test(location.search)) src = 'campaign';

  var pageType = (document.body.className.match(/tpl-([a-z_]+)/) || [])[1] || 'other';
  track('page_view_ez', { page_type: pageType, traffic_source: src });

  /* ---- article engagement: reading time + scroll depth ---- */
  var art = document.querySelector('[data-article]');
  if (art) {
    var words = (art.innerText || '').trim().split(/\s+/).length;
    var mins = Math.max(1, Math.round(words / 225));
    var slot = document.querySelector('[data-readtime]');
    if (slot) slot.textContent = mins + ' min read';
    track('article_view', { article: art.getAttribute('data-article'), words: words, read_minutes: mins, traffic_source: src });

    var hits = {};
    window.addEventListener('scroll', function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return;
      var pct = Math.round((window.scrollY / h) * 100);
      [25, 50, 75, 100].forEach(function (m) {
        if (pct >= m && !hits[m]) { hits[m] = 1; track('article_scroll', { depth: m, article: art.getAttribute('data-article') }); }
      });
    }, { passive: true });
  }

  /* ---- internal / product / collection click tracking ---- */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('/products/') === 0) track('product_click', { to: href, from: pageType });
    else if (href.indexOf('/collections/') === 0) track('collection_click', { to: href, from: pageType });
    else if (href.indexOf('/blogs/') === 0) track('article_click', { to: href, from: pageType });
    else if (href.indexOf('#mockup') > -1 || href.indexOf('request-a-quote') > -1) track('conversion_click', { to: href, from: pageType });
  });

  /* ---- share buttons ---- */
  document.querySelectorAll('[data-share]').forEach(function (el) {
    el.addEventListener('click', function (ev) {
      var net = el.getAttribute('data-share');
      track('article_share', { network: net, url: location.href });
      if (net === 'copy') {
        ev.preventDefault();
        if (navigator.clipboard) navigator.clipboard.writeText(location.href);
        var old = el.getAttribute('aria-label');
        el.setAttribute('aria-label', 'Link copied');
        setTimeout(function () { el.setAttribute('aria-label', old); }, 1800);
      }
    });
  });

  /* ---- blog search (client side, no app needed) ---- */
  var box = document.getElementById('blogFilter');
  if (box) {
    box.addEventListener('input', function () {
      var q = box.value.trim().toLowerCase();
      var shown = 0;
      document.querySelectorAll('[data-searchable]').forEach(function (c) {
        var hit = !q || (c.getAttribute('data-searchable') || '').indexOf(q) > -1;
        c.style.display = hit ? '' : 'none';
        if (hit) shown++;
      });
      var none = document.getElementById('blogNoResults');
      if (none) none.style.display = shown ? 'none' : '';
      if (q.length > 2) track('blog_search', { query: q, results: shown });
    });
  }
})();
